import * as R from "ramda";
import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

import { Artifact } from "../../../types/artifact";
import { ARTIFACT_TAB_MAP } from "../../viewer/tabs";

const FIRST_ROW_INDEX = 0;

const AUTO_OPEN_PARAM_KEYS = ["auto_open", "artifact"] as const;

const withoutAutoOpenParams = (searchParams: URLSearchParams): URLSearchParams => {
  const stripped = new URLSearchParams(searchParams);
  AUTO_OPEN_PARAM_KEYS.forEach((key) => stripped.delete(key));
  return stripped;
};

interface UseExploreAutoOpenParams {
  artifacts: Artifact[];
  loading: boolean;
  setSelectedInteractionId: React.Dispatch<React.SetStateAction<string | null>>;
  setIsViewerPanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setViewerInitialTab: React.Dispatch<React.SetStateAction<number>>;
}

export const useExploreAutoOpen = ({
  artifacts, loading, setSelectedInteractionId, setIsViewerPanelOpen, setViewerInitialTab
}: UseExploreAutoOpenParams): void => {
  const [searchParams, setSearchParams] = useSearchParams();
  const autoOpenProcessed = useRef(false);

  useEffect(() => {
    if (autoOpenProcessed.current) {
      return;
    }
    const autoOpen = searchParams.get("auto_open");
    const artifact = searchParams.get("artifact");
    if (autoOpen !== "first" || loading) {
      return;
    }
    autoOpenProcessed.current = true;
    setSearchParams(withoutAutoOpenParams(searchParams), { replace: true });
    if (R.isEmpty(artifacts)) {
      return;
    }
    const firstArtifact = artifacts[FIRST_ROW_INDEX];
    if (!firstArtifact?.interaction_id) {
      return;
    }
    setSelectedInteractionId(firstArtifact.interaction_id);
    setIsViewerPanelOpen(true);
    if (artifact && ARTIFACT_TAB_MAP[artifact] !== undefined) {
      setViewerInitialTab(ARTIFACT_TAB_MAP[artifact]);
    }
  }, [searchParams, loading, artifacts, setSearchParams, setSelectedInteractionId, setIsViewerPanelOpen, setViewerInitialTab]);
};
